import { Component, OnInit } from '@angular/core';
import swal from 'sweetalert2';
import {DataIspaccService} from '../utils/data-services/dataIspacc.service';

@Component({
  selector: 'app-soft-drop',
  templateUrl: './soft-drop.component.html',
  styleUrls: ['./soft-drop.component.scss']
})
export class SoftDropComponent implements OnInit {

  fileName = null;
  wrongFormat = false;
  file = null;

  constructor(
    public ispaService: DataIspaccService
  ) { }

  ngOnInit() {

  }

  chargeFile(file) {
    this.file = file;
    this.wrongFormat = !this.file.type.split('/').includes('csv') && !this.file.type.split('/').includes('vnd.ms-excel');
    this.fileName = file ? `${file.name} (${(file.size / 1024).toFixed(1)} Ko)` : null;
  }

  dragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }
  dragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }
  dropHandler(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    const file = event.dataTransfer.files[0];
    this.chargeFile(file);
  }


  sendFile() {
    swal.fire({
      title: 'Traitement en cours',
      text: 'Le traitement du fichier est en cours. Cette opération peut nécessiter quelques instants. Un message s’affichera automatiquement une fois le traitement terminé.',
      type: 'info',
      confirmButtonText: 'Ok',
    });
    const formData = new FormData();
    const info = {
      file_size: this.file.size,
      file_type: this.file.type,
      uploaded_by: sessionStorage.getItem('User'),
    };
    formData.append('file', this.file, this.file.name);
    formData.append('info', JSON.stringify(info));
    this.ispaService.requestUploadSoftDropFile(sessionStorage.getItem('token'), formData).subscribe(res => {
      this.fileName = null;
      this.wrongFormat = false;
      this.file = null;
      swal.fire({
        title: 'Traitement terminé',
        text: 'Le fichier Soft-Drop a été importé avec succès.',
        type: 'success',
        confirmButtonText: 'Ok',
      });
    }, err => {
      swal.fire({
        title: 'Attention',
        text: 'Un problème est survenu lors de l\'importation du fichier, veuillez réessayer ultérieurement.',
        type: 'error',
        confirmButtonText: 'Ok',
      });
    });
  }
}
